"use client";

import { createContext, useContext, useMemo } from "react";

const UserContext = createContext();

export function UserProvider({ children, user, updateUser, setUser, onSignOut, isPendingSignIn }) {
  const context = useMemo(() => {
    return {
      user,
      updateUser,
      setUser,
      operator: user
        ? {
            id: user.customerId || user.uid,
            name: (user.checkInStaff ? user.checkInStaff.name : user.name) || "",
          }
        : null,
      isPendingSignIn,
      onSignOut,
    };
  }, [user, updateUser, onSignOut, isPendingSignIn]);

  return <UserContext.Provider value={context}>{children}</UserContext.Provider>;
}

export const useUser = () => useContext(UserContext).user;
export const useUserSignOut = () => useContext(UserContext).onSignOut;
export const useUserUpdate = () => useContext(UserContext).updateUser;
export const useUserSetter = () => useContext(UserContext).setUser;
export const useUserIDName = () => useContext(UserContext).operator;
export const useUserIsPendingSignIn = () => useContext(UserContext).isPendingSignIn;
// User helper hooks
export const useUserRealmId = () => useContext(UserContext).user?.realmId;
export const useUserStorageBucket = () => useContext(UserContext).user?.bucket;
export const useUserBusinessCode = () => useContext(UserContext).user?.businessCode;
export const useUserLocationCenter = () => useContext(UserContext).user?.locationCenter;
export const useUserIsTestMode = () => useContext(UserContext).user?.isTestMode;
export const useUserStripeAccount = () => useContext(UserContext).user?.stripeAccount;
export const useUserCountryCode = () => useContext(UserContext).user?.countryCode;
export const useUserDialCode = () => useContext(UserContext).user?.dialCode;
export const useUserTimezone = () => useContext(UserContext).user?.timeZone;
export const useUserCurrency = () => useContext(UserContext).user?.currency;
export const useUserLocationName = () => useContext(UserContext).user?.locationName;
export const useUserUID = () => useContext(UserContext).user?.uid;
export const useUserName = () => useContext(UserContext).user?.name;
export const useUserEmail = () => useContext(UserContext).user?.email;
export const useUserCustomerId = () => useContext(UserContext).user?.customerId;
export const useUserIsRealmMaster = () => useContext(UserContext).user?.realmMaster;
export const useUserDebugMode = () => useContext(UserContext).user?.debugMode;
export const useUserTestMode = () => useContext(UserContext).user?.isTestMode;
export const useUserPairedDeviceId = () => useContext(UserContext).user?.connectDeviceId;
export const useUserAuthTime = () => useContext(UserContext).user?.authTime;
export const useUserClockInIDName = () => useContext(UserContext).user?.checkInStaff;

// TODO: FETCH FROM TOKEN
export const useUserStorageHost = () => process.env.REACT_APP_storage_host || process.env.NEXT_PUBLIC_storage_host;
export const useUserGoogleMapKey = () => process.env.REACT_APP_google_map_pk || process.env.NEXT_PUBLIC_google_map_pk;
